import Parser from 'html-react-parser';
import * as Immutable from 'immutable';
import * as React from 'react';
import { injectIntl, WrappedComponentProps as InjectedIntlProps } from 'react-intl';
import { connect } from 'react-redux';
import { Loader } from 'semantic-ui-react';

import { StateType } from '../../reducers';
import { messagesIsFetchingMarkReadSelector } from '../../reducers/MessagesReducer/MessagesSelector';
import { addModifiers } from '../../shared/helpers';
import { Card } from '../Card';

interface MessageListProps {
  data: any;
  handleMarkAsRead: (e: any) => void;
  isFetching: boolean;
}

interface TimeElapsedElemProps {
  dateCreated: Date;
  handler: () => void;
  isRead: boolean;
  id: string;
}

interface TimeElapsedElemStateToProps {
  isFetchingMarkRead: Immutable.List<string>;
}

const timeElapsed = (date: Date) => {
  const getDays = (miliseconds: Number) => Math.floor(+miliseconds / (24 * 60 * 60 * 1000));
  const dateReceived = +new Date(date);
  const elapsedMiliseconds = Math.abs(+new Date() - dateReceived);
  const elapsed = getDays(elapsedMiliseconds);

  return String(elapsed);
};

const TimeElapsedElemMain = ({
  dateCreated,
  handler,
  isRead,
  isFetchingMarkRead,
  id,
}: TimeElapsedElemStateToProps & TimeElapsedElemProps) => (
  <div className="messages-list__actions">
    <div className="card__header-elem--message">{timeElapsed(dateCreated)} days ago</div>
    {isRead === false && (
      <div>
        {!isFetchingMarkRead.includes(id) && (
          <span className="card__header-link card__header-link--btn-orange" onClick={handler}>
            Mark as Read
          </span>
        )}
        {isFetchingMarkRead.includes(id) && (
          <div>
            <Loader active={true} inline="centered" size="small" />
          </div>
        )}
      </div>
    )}
  </div>
);
const mapStateToProps = (state: StateType): TimeElapsedElemStateToProps => ({
  // @ts-ignore
  isFetchingMarkRead: messagesIsFetchingMarkReadSelector(state),
});

const TimeElapsedElem = connect<TimeElapsedElemStateToProps, {}, {}, StateType>(mapStateToProps, {})(TimeElapsedElemMain);

export const MessagesListIntl = ({ data, handleMarkAsRead, isFetching }: MessageListProps & InjectedIntlProps) => (
  <div className={addModifiers('messages__list', isFetching ? ['hide'] : [])}>
    {data &&
      data.map((message: any) => {
        const handler = () => {
          handleMarkAsRead(message.get('id'));
        };

        return (
          <Card
            key={`${message.get('id')}`}
            messageId={`${message.get('id')}`}
            title={message.get('title')}
            hasHeader={true}
            headerRightElem={
              <TimeElapsedElem
                dateCreated={message.get('dateCreated')}
                isRead={message.get('read')}
                handler={handler}
                id={message.get('id')}
              />
            }
            modifiers={['message', message.get('id')]}
            modifiersHeaderLink={['btn-orange']}
            modifiersTitle={['message-title']}
            modifiersContent={['message-body']}
          >
            <div>{message.get('description') && Parser(message.get('description'))}</div>
          </Card>
        );
      })}
  </div>
);

export const MessagesList = injectIntl(MessagesListIntl);
